import React, { useRef } from 'react';
import {
  Link,
  MoreInfoCard,
  MoreInfoCardBody,
  MoreInfoCardGrid,
  MoreInfoCardImage,
  SecondarySection,
  SectionSubTitle,
} from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { createElementKey } from 'utils';
import { analyticsUtils } from 'utils/analytics-utils';
import {
  METAL_ROOF_TYPES_LIST,
  METAL_ROOF_TYPES_WITH_SEAM_ROOFING_LIST,
  MetalRoofMoreInfoCardStructure,
} from './metal-roof-types-section-constants';

type MetalRoofTypesSectionProps = {
  elementBlock: string;
  withSeamRoofing: boolean;
};

export const MetalRoofTypesSection = ({ elementBlock, withSeamRoofing }: MetalRoofTypesSectionProps) => {
  const cardRefs = useRef<HTMLAnchorElement[]>([]);

  const typesList = withSeamRoofing ? METAL_ROOF_TYPES_WITH_SEAM_ROOFING_LIST : METAL_ROOF_TYPES_LIST;

  const promotions = typesList.map(({ title }: MetalRoofMoreInfoCardStructure, index: number) => ({
    name: elementBlock,
    creative: title,
    position: (index + 1).toString(),
  }));

  usePromoViewEvent(cardRefs, elementBlock, promotions);

  /**
   * Обработчик нажатия на карточку со стилями
   */
  const handleCardClick = (index: number) => () => {
    analyticsUtils.promoClickEvent(elementBlock, promotions[index]);
  };

  return (
    <SecondarySection>
      <SectionSubTitle margin="m">Предлагаем все виды материалов</SectionSubTitle>

      <MoreInfoCardGrid cardNumber={typesList.length} cardPerRow={2}>
        {typesList.map(({ imgSrc, title, link }, index) => (
          <Link
            key={createElementKey('mounting-type', index)}
            {...link}
            onClick={handleCardClick(index)}
            data-position={index}
            refCb={(el: HTMLAnchorElement | null) => {
              if (el && cardRefs) cardRefs.current[index] = el;
            }}>
            <MoreInfoCard>
              <MoreInfoCardImage src={imgSrc} alt={title} title={title} />
              <MoreInfoCardBody title={title} />
            </MoreInfoCard>
          </Link>
        ))}
      </MoreInfoCardGrid>
    </SecondarySection>
  );
};
